/* ============================================================
   YOLÈTE — Article : rendu d'un article depuis ?slug=
   ============================================================ */

/* Adresse du site (?slug=) ou adresse native d'un article Shopify
   (/blogs/yolete/<handle>, gabarit article.liquid qui pose YOLETE_ROUTE). */
const slug = new URLSearchParams(location.search).get('slug')
  || (window.YOLETE_ROUTE && YOLETE_ROUTE.kind === 'article' ? YOLETE_ROUTE.handle : null);
const article = ARTICLES.find(a => a.slug === slug);
const root = document.getElementById('articleRoot');

/* /pages/article sans slug répond 200 en affichant « Article introuvable » :
   c'est un soft 404 pour Google. On le marque noindex plutôt que de le laisser
   entrer dans l'index. */
if (!article) {
  (function () {
    var m = document.querySelector('meta[name="robots"]');
    if (!m) { m = document.createElement('meta'); m.name = 'robots'; document.head.appendChild(m); }
    m.content = 'noindex, follow';
  })();
}

if (!article) {
  root.innerHTML = `
    <div class="wrap article-missing">
      <h1 class="section-title">Article introuvable</h1>
      <p>Cet article n'existe pas ou a été déplacé.</p>
      <a href="/pages/magazine" class="btn btn-dark">Retour au magazine</a>
    </div>`;
} else {
  /* Un article de l'admin a son adresse Shopify comme adresse de référence */
  const canonique = article.url ? location.origin + article.url : undefined;
  if (typeof setSEO === 'function') setSEO(`${article.title} · Magazine Yolète`, article.excerpt || '', canonique); else document.title = `${article.title} · Magazine Yolète`;

  const isPress = article.type === 'presse';
  const byline = isPress
    ? `Paru dans <strong>${article.source}</strong>${article.issue ? ' · ' + article.issue : ''}`
    : `Par ${article.author} · ${frDate(article.date)} · ${article.readMins} min`;

  const pressCallout = isPress ? `
    <aside class="press-note">
      <p><span class="eyebrow">Revue de presse</span></p>
      <p>Cet article relaie un sujet paru dans <strong>${article.source}</strong>${article.issue ? ` (${article.issue})` : ''}.</p>
      ${article.link ? `<a href="${article.link}" target="_blank" rel="noopener" class="btn btn-line">Lire chez ${article.source}</a>` : ''}
    </aside>` : '';

  root.innerHTML = `
    <article class="post">
      <header class="post-head wrap">
        <nav class="crumb"><a href="/pages/magazine">Magazine</a> · <span>${ARTICLE_TYPE[article.type]}</span></nav>
        <p class="eyebrow">${isPress ? 'Presse' : 'Le Journal'}</p>
        <h1>${article.title}</h1>
        <p class="post-byline">${byline}</p>
      </header>

      <div class="post-cover wrap">
        <img src="${article.cover}" alt="${article.title}" />
      </div>

      <div class="post-body wrap">
        ${article.shopify ? corpsPropre(article.body) : article.body}
        ${pressCallout}
        <a href="/pages/magazine" class="btn btn-line post-back">← Retour au magazine</a>
      </div>
    </article>

    <section class="more-articles wrap">
      <h2 class="section-title">À lire aussi</h2>
      <div class="article-grid" id="moreGrid"></div>
    </section>`;

  /* Articles liés (3 autres, même type prioritaire) */
  const others = ARTICLES.filter(a => a.slug !== article.slug)
    .sort((a, b) => (b.type === article.type) - (a.type === article.type))
    .slice(0, 3);
  document.getElementById('moreGrid').innerHTML = others.map(a => `
    <a class="article-card" href="${articleHref(a)}">
      <div class="article-media">
        <span class="article-kind">${a.type === 'presse' ? 'Presse' + (a.source ? ' · ' + a.source : '') : 'Le Journal'}</span>
        <img src="${a.cover}" alt="${a.title}" loading="lazy" />
      </div>
      <div class="article-body">
        <div class="article-meta">${articleMeta(a)}</div>
        <h3>${a.title}</h3>
      </div>
    </a>`).join('');

  observeReveals();
}
